/** A straight tuck's tongue, for a box's front `L` and side `W` as Die Cut
 * Studio's builders measure them: as deep as the side or so, never
 * shallower than its corners allow. Written once over `ops` — the die's mm,
 * the grow's expressions —, `inch` in their own units. */
export const DieCutStudioTongue = <T>(
  L: T,
  W: T,
  ops: {
    min: (a: T, b: T) => T
    max: (a: T, b: T) => T
    add: (a: T, b: T) => T
    times: (a: T, f: number) => T
    inch: (v: number) => T
  }
): T =>
  ops.max(
    ops.min(ops.times(W, 0.55), ops.inch(0.7)),
    ops.add(ops.min(ops.inch(0.4), ops.times(L, 0.18)), ops.inch(0.15))
  )
